module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAATCAYAAABPwleqAAAACXBIWXMAAAsTAAALEwEAmpwYAAABFklEQVQ4jZWTvUpDQRCFT266gIUpJCEpTB19DRGxFwMJlr6B+AI+gcQitY1gZWdjgkLyHlHiHyqiTZB8FtmV67ibez2wLDN7vmHY3RGg1CoAu8AF8ADMgHsX77jzH38arAMjFmsI1CxcBW4zQK8xUEnD/Zyg15WHtyKGGfDo9pA2E0kd/VVf0qqkFUkNSYOApy3gzlR8A5b5/Qpl4N34xomkiqk4kPRqci+Srk2umkhKTHIp0KIklUxcFPBs2vkC1kzb6y6f1pOAs8BNToC2g/aY/zKrcwEbkafI0rZv6/Kf4A1Q8HAD+MwJToEmZjBaOeF9AlMl4CgDPCYykn6eTyLgKVBcBPsCXQP2LBiD/ToEPoCDmOcbpW1pVQuC/4gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/station-icon-adress1.png
// module id = ITtF
// module chunks = 1